export { default } from './app'



// WEBPACK FOOTER //
// ./src/containers/app/index.js